import { RefObject } from "react";

/**
 * The HTML Element that will be collapsing/expanding when the event is triggered
 */
//collapsedContainerRef: RefObject<HTMLElement>;

/**
 * Instance-specific code to run when the element is closing
 */
//closeEvent?: () => void;

/**
 * Instance-specific code to run when the element is opening
 */
//openEvent?: () => void;

/**
 * A simple function to replicate bootstrap's expand/collapse functionality in a given element.
 * Usage: Place this function inside an onClick handler. The collapsed container must start with the class qes-js-open or qes-js-closed.
 */
export const expandCollapse = (collapsedContainerRef: RefObject<HTMLElement>, closeEvent?: () => void, openEvent?: () => void, delayMs?: number): void => {
  if (!collapsedContainerRef.current) return;
  const isOpen = collapsedContainerRef.current.classList.contains("qes-js-open");
  const noDelay = delayMs === 0;
  if (isOpen) {
    collapsedContainerRef.current.style.height = `${collapsedContainerRef.current.scrollHeight}px`;
    collapsedContainerRef.current.classList.remove("qes-js-closed", "qes-js-open");
    if (!noDelay) {
      collapsedContainerRef.current.classList.add("qes-js-transition");
    }
    if (closeEvent) closeEvent();
    window.requestAnimationFrame(() => {
      if (!!collapsedContainerRef.current) {
        collapsedContainerRef.current.style.height = null;
        // If the delay should be 0, just skip the setTimeout - 
        // setTimeout with 0 still waits for the next event cycle to trigger,
        // and may take longer than anticipated
        if (noDelay) {
          collapsedContainerRef.current.classList.remove("qes-js-transition");
          collapsedContainerRef.current.classList.add("qes-js-closed");
        } else {
          window.setTimeout(() => {
            if (!!collapsedContainerRef.current) {
              collapsedContainerRef.current.classList.remove("qes-js-transition");
              collapsedContainerRef.current.classList.add("qes-js-closed");
            }
          }, delayMs || 300);
        }
      }
    });
  } else {
    collapsedContainerRef.current?.classList.remove("qes-js-closed");
    if (!noDelay) {
      collapsedContainerRef.current?.classList.add("qes-js-transition");
    }
    if (!!collapsedContainerRef.current) {
      collapsedContainerRef.current.style.height = `${collapsedContainerRef.current.scrollHeight}px`;
      if (openEvent) openEvent();
      window.requestAnimationFrame(() => {
        if (noDelay) {
          collapsedContainerRef.current.classList.remove("qes-js-transition");
          collapsedContainerRef.current.classList.add("qes-js-closed", "qes-js-open");
        } else {
          window.setTimeout(() => {
            if (!!collapsedContainerRef.current) {
              collapsedContainerRef.current.classList.remove("qes-js-transition");
              collapsedContainerRef.current.classList.add("qes-js-closed", "qes-js-open");
              collapsedContainerRef.current.style.height = null;
            }
          }, delayMs || 300);
        }
      });
    }
  }
};
